import React from "react";
import MainLayout from "../../Layout/mainLayout";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addNewCategory } from "../../Redux/Actions/categoryActions";
import AddImage from "../../Global Functions/addImage";
import TextInput from "../../Global Functions/textInput";
import ImageShowerModal from "../../Global Functions/imageShowerModal";
import toast from "react-hot-toast";

const AddCategories = () => {
  const [categoryState, setCategoryState] = useState({
    name: "",
    image: "",
    position: Math.floor(Math.random() * 1000) + 1,
    icon: "",
    three_d_icon: "",
  });

  const handleFileChange = async (event, type) => {
    const uploadedImage = event.target.files[0];

    if (!uploadedImage) return;

    const responseUrl = await AddImage(uploadedImage);
    if (responseUrl) {
      setCategoryState((prevData) => ({ ...prevData, [type]: responseUrl }));
    }
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await dispatch(addNewCategory(categoryState));
      if (response.statusCode === 200) {
        navigate("/categories");
      } else {
        return toast.error(response?.message);
      }
      setCategoryState({
        name: "",
        icon: "",
        image: "",
      });
    } catch (error) {
      return toast.error(error?.message);
    }
  };

  return (
    <MainLayout>
      <div
        style={{
          marginTop: "10px",
          paddingTop: "10px",
          background: "white",
          width: "100%",
          borderRadius: "25px",
          gridColumn: "2/7",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0px 20px",
          }}
        >
          <h1>Add Category</h1>
          <Link to="/categories">
            <button className="button-class">View Category List</button>
          </Link>
        </div>
        <form style={{ padding: "20px" }} onSubmit={handleSubmit}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Category Image
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="image"
                onChange={(event) => handleFileChange(event, "image")}
                name="image"
              />
              <label className="label-class-image" htmlFor="image">
                Click to Upload Image
              </label>
              {categoryState.image ? (
                <ImageShowerModal
                  file={categoryState.image}
                  onClick={() => {
                    setCategoryState((prevData) => ({
                      ...prevData,
                      image: "",
                    }));
                  }}
                ></ImageShowerModal>
              ) : null}
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload Category Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="icon"
                onChange={(event) => handleFileChange(event, "icon")}
                name="icon"
              />
              <label className="label-class-image" for="icon">
                Click to Upload Icon
              </label>
              {categoryState.icon ? (
                <ImageShowerModal
                  file={categoryState.icon}
                  onClick={() => {
                    setCategoryState((prevData) => ({
                      ...prevData,
                      icon: "",
                    }));
                  }}
                ></ImageShowerModal>
              ) : null}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              gap: "10px",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "50%" }}>
              <TextInput
                value={categoryState.name}
                onChange={(event) =>
                  setCategoryState({
                    ...categoryState,
                    name: event.target.value,
                  })
                }
                placeholder="Enter Name"
                label="Category Name"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <span className="span-class" htmlFor="add-image">
                Upload 3D Icon
              </span>
              <input
                style={{
                  display: "none",
                }}
                type="file"
                id="three_d_icon"
                onChange={(event) => handleFileChange(event, "three_d_icon")}
                name="three_d_icon"
              />
              <label className="label-class-image" for="three_d_icon">
                Click to Upload Icon
              </label>
              {categoryState.three_d_icon ? (
                <ImageShowerModal
                  file={categoryState.three_d_icon}
                  onClick={() => {
                    setCategoryState((prevData) => ({
                      ...prevData,
                      three_d_icon: "",
                    }));
                  }}
                ></ImageShowerModal>
              ) : null}
            </div>
          </div>
          <div className="flex-end" style={{ margin: "20px auto" }}>
            <div>
              <Link to="/categories">
                <button className="button-class-white">Cancel</button>
              </Link>
              <button className="button-class" type="submit">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddCategories;
